import { API_ENDPOINT, QueryKeys } from "@cede/utils";
import { useApi } from "@/hooks/core/useApi";
import { useHubUser } from "@/hooks/user/useHubUser";
import { useQuery } from "@tanstack/react-query";

interface UseSpinningWheelTicketsOptions {
  enabled?: boolean;
}

/**
 * Hook to fetch spinning wheel tickets for the authenticated user
 * Returns the count of active tickets available for spinning
 */
export const useSpinningWheelTickets = (options?: UseSpinningWheelTicketsOptions) => {
  const { hubUser, auth } = useHubUser();
  const apiHelper = useApi();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [QueryKeys.SPINNING_WHEEL_TICKETS, hubUser?.id],
    queryFn: async () => {
      const result = await apiHelper.getWithAuth(auth, API_ENDPOINT.SPINNING_WHEEL_TICKETS);
      return result.totalTickets;
    },
    enabled: (options?.enabled ?? false) && !!hubUser?.id, // Changed default to false
    staleTime: 30 * 1000, // 30 seconds
    retry: 2,
  });

  return {
    tickets: data ?? 0,
    isLoading,
    error: error?.message ?? null,
    refetch,
  };
};
